import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import LayawayView from "components/Containers/LayawayView"
import {Tab, Tabs, Card, CardContent} from "@material-ui/core";

import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Types from "../../../../../constants/Types";
import {confirmAlert} from "react-confirm-alert";
import {toast} from "react-toastify";
import {PrintReceiptModal} from "../../../../../containers/Print";
import {formatLayawayMoney, layawayRefundDue} from "../../../../../utils/layawayRefundDue";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Layaways',
		url: '/layaways',
		icon: 'hourglass',
	}
];

class Layaway extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.tab = 'details'
		this.state.remaining = 0;
		this.state.layawayClosed = false;
		this.state.modalRefund = false;
		this.state.refundPayments = [];
		this.state.refundedPaymentKeys = [];
		this.state.refundRestockItems = [];
		this.state.Rkey = Math.random();
		this.transactionRef = React.createRef();
		this.transactionItemsRef = React.createRef();
		this.paymentsRef = React.createRef();
	}

	handleAfterSave = () => {
		this.setState({Rkey: Math.random()})
	}
	handleDelete = () => {
		let model = new API.BuildClass(Types.Layaways._name, API.RequestType.DELETE);
		model.object.pkey = this.props.id;
		confirmAlert({
			title: 'Confirm Delete',
			message: (
				<span>
					This will delete all logs and entries tied to this layaway. <strong>This will not refund payments or
					restock items if deleted.</strong> Are you sure you want to delete this?
				</span>
			),
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							await model.submit(null, API.RequestType.DELETE);
							this.props.history.push('/layaways');

						} catch (error) {
							console.error(error);
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	handleCheckoutIncrement = () => {
		this.props.rootState.set({
			session_items_count: this.props.rootState.session_items_count === null ? 1 : 1 + this.props.rootState.session_items_count
		});
	}

	handlePrintReceipt = async () => {
		try {
			if (!this.transactionRef.current || !this.transactionItemsRef.current) {
				API.ToastId = toast.warning('Layaway details are still loading. Please try again.', {
					position: toast.POSITION.TOP_CENTER,
				});
				return;
			}

			const customizationId = this.props.rootState.receiptCustomizationId;
			let rData = {items: [{}]};
			if (customizationId) {
				let rModel = new API.BuildClass(Types.Accounts_Customizations._name, API.RequestType.READ_ALL);
				rModel.parent = customizationId;
				rData = await rModel.submit(null, API.RequestType.READ_ALL);
			}

			const paymentData = this.paymentsRef.current?.state?.data ?? [];
			const transactionData = this.transactionRef.current.state;
			const transactionItemData = this.transactionItemsRef.current.state;

			const refundModel = new API.BuildClass(Types.Layaways_Payment_Refunds._name, API.RequestType.READ_ALL);
			refundModel.parent = this.props.id;
			let refundData = {items: []};
			try {
				refundData = await refundModel.submit(null, API.RequestType.READ_ALL);
			} catch (e) {
				refundData = {items: []};
			}

			const props = this.props;

			confirmAlert({
				customUI: ({onClose}) => {
					return (
						<PrintReceiptModal
							layaway={true}
							onClose={onClose}
							account={this.props.rootState.account}
							data={transactionData}
							rData={rData}
							pData={paymentData}
							refundData={refundData}
							items={transactionItemData}
							props={props}
						/>
					);
				},
			});
		} catch (error) {
			console.error(error);
			API.ToastId = toast.error('Unable to open print receipt preview.', {
				position: toast.POSITION.TOP_CENTER,
			});
		}
	};

	handleSendReceipt = async () => {
		let {current} = this.transactionRef;
		current.sendReceipt.call({current}, null);
	};

	readAllItems = (data) => {
		if (Array.isArray(data?.items)) {
			return data.items;
		}
		if (Array.isArray(data)) {
			return data;
		}
		if (Array.isArray(data?.[0])) {
			return data[0];
		}
		return [];
	};

	refundPaymentPkey = (refundRow) => {
		if (refundRow == null) {
			return NaN;
		}
		if (typeof refundRow.payment === "object" && refundRow.payment != null) {
			return Number(refundRow.payment.pkey);
		}
		if (refundRow.layaway_payments != null) {
			return Number(refundRow.layaway_payments.pkey ?? refundRow.layaway_payments);
		}
		return Number(refundRow.payment);
	};

	loadRefundModalData = async () => {
		const payModel = new API.BuildClass(Types.Layaways_Payments._name, API.RequestType.READ_ALL);
		payModel.parent = this.props.id;
		const payData = await payModel.submit(null, API.RequestType.READ_ALL);

		const refundModel = new API.BuildClass(Types.Layaways_Payment_Refunds._name, API.RequestType.READ_ALL);
		refundModel.parent = this.props.id;
		let refundData = {items: []};
		try {
			refundData = await refundModel.submit(null, API.RequestType.READ_ALL);
		} catch (e) {
			refundData = {items: []};
		}

		const payments = this.readAllItems(payData);
		const refunds = this.readAllItems(refundData);
		const refundedPaymentKeys = refunds
			.map((r) => this.refundPaymentPkey(r))
			.filter((n) => Number.isFinite(n) && n > 0);

		let restockItems = [];
		try {
			const entriesModel = new API.BuildClass(Types.Layaways_Entries._name, API.RequestType.READ);
			entriesModel.parent = this.props.id;
			const entriesData = await entriesModel.submit(null, 'GET');
			restockItems = Array.isArray(entriesData?.items) ? entriesData.items : [];
			restockItems = restockItems.filter((e) => {
				const t = String(e?.type || "").toLowerCase();
				return t === "item" || t === "consignment";
			});
		} catch (e) {
			const fromRef = this.transactionItemsRef.current?.state?.entries || [];
			restockItems = Array.isArray(fromRef)
				? fromRef.filter((e) => {
					const t = String(e?.type || "").toLowerCase();
					return t === "item" || t === "consignment";
				})
				: [];
		}

		return {payments, refundedPaymentKeys, restockItems};
	};

	toggleRefund = async () => {
		if (this.state.modalRefund === false) {
			try {
				const {payments, refundedPaymentKeys, restockItems} = await this.loadRefundModalData();
				const refundable = payments.filter((p) => {
					const amt = parseFloat(p.amount);
					if (!Number.isFinite(amt) || amt <= 0) return false;
					if (String(p.payment_method || "").toLowerCase() === "adjustment") return false;
					return !refundedPaymentKeys.includes(Number(p.pkey));
				});
				if (refundable.length === 0) {
					API.ToastId = toast.info("No refundable payments on this layaway.", {
						position: toast.POSITION.TOP_CENTER,
					});
					return;
				}
				this.setState({
					refundPayments: payments,
					refundedPaymentKeys,
					refundRestockItems: restockItems,
					modalRefund: true,
				});
			} catch (e) {
				API.ToastId = toast.error("Unable to load payments for refund.", {
					position: toast.POSITION.TOP_CENTER,
				});
			}
			return;
		}
		this.setState({modalRefund: false});
	};

	handleRefundModalAfterSave = async () => {
		this.setState({
			modalRefund: false,
			Rkey: Math.random(),
		});
	};

	closeRefundModal = () => {
		this.setState({modalRefund: false});
	};

	render() {
		const {tab} = this.state;
		const refundDue = layawayRefundDue(this.state.remaining);
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/layaways/${this.props.id}`,
				icon: 'edit',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button size={'sm'} className="primary-button" onClick={this.handlePrintReceipt} block={false}>Print
						Receipt</Button>
					<Button size={'sm'} className="secondary-button" onClick={this.handleSendReceipt}>Email Receipt</Button>
					{this.state.remaining > 0 && !this.state.layawayClosed && <Button className="primary-button" data-id="add-certificate" onClick={async () => {
						$.ajax({
							type: "PUT",
							url: APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/checkouts/layaways',
							data: {
								object: JSON.stringify({
									"checkout": "",
									"layaway": this.props.id,
								}),
							},
							success: (data) => {
								API.ToastId = toast.info('Layaway payment added to cart.', {
									position: toast.POSITION.TOP_RIGHT
								});
								this.handleCheckoutIncrement();
								this.props.history.push('/checkout');
							},
							error: function (xhr, status, error) {
								let errorMessage = xhr.responseJSON.response
								API.ToastId = toast.warning(errorMessage, {
									position: toast.POSITION.TOP_CENTER
								});
							}
						});
					}
					} size={"sm"}>
						<i className="fa fa-usd"/>&nbsp;&nbsp;Add Payment
					</Button>}
					<Button
						size={"sm"}
						color={refundDue > 0.005 ? "warning" : undefined}
						className={refundDue > 0.005 ? undefined : "primary-button"}
						onClick={this.toggleRefund}
						block={false}
					>
						Refund
						{refundDue > 0.005 ? ` ($${formatLayawayMoney(refundDue)} due)` : ""}
					</Button>
					<Button size={"sm"} className="danger-button" color='danger' onClick={this.handleDelete}>
						<i className="fa fa-ban"/>&nbsp;&nbsp;Delete
					</Button>
				</Framework.Components.PageBar>
				<Tabs value={tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Layaway" value="details"/>
					<Tab label="Payments" value="payments"/>
				</Tabs>
				{tab === 'details' && (
					<LayawayView
						refTransaction={this.transactionRef}
						refTransactionItems={this.transactionItemsRef}
						id={this.props.id}
						history={this.props.history}
						locations={this.props.locations}
						setRemaining={(val) => this.setState({remaining: val})}
						setLayawayClosed={(closed) => this.setState({layawayClosed: closed})}
					/>
				)}
				{tab === 'payments' && (
					<>
						<Card>
							<CardContent>
								<Collections.LayawayPayments
									key={this.state.Rkey}
									ref={this.paymentsRef}
									parent={this.props.id}
									history={this.props.history}
									reloadShell={this.props.reloadShell}
									reloadPage={this.refreshPage}
									reloadSelf={this.state.refresh}
								/>
							</CardContent>
						</Card>
						<Card className="mt-3">
							<CardContent>
								<h5 className="mb-2">Refunds</h5>
								<Collections.LayawayPaymentRefunds
									key={this.state.Rkey}
									parent={this.props.id}
									history={this.props.history}
								/>
							</CardContent>
						</Card>
					</>
				)}
				<Framework.Elements.UniversalModal
					parent={this.props.id}
					locations={this.props.locations}
					name={"Layaway"}
					title={'Make Payment'}
					submitLabel={'Submit Payment'}
					object={Objects.Payment}
					history={this.props.history}
					toggle={this.state['modalPayment']}
					reportClose={this.reportClose('modalPayment')}
					afterSave={this.handleAfterSave}
					size={'lg'}
				/>
				<Framework.Elements.UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					title={"Refund"}
					name={"Refunds"}
					submitLabel={"Refund"}
					parent={this.props.id}
					object={Objects.LayawayPaymentRefund}
					objectProps={{
						layaway: this.props.id,
						refundDue,
						payments: structuredClone(this.state.refundPayments || []),
						refundedPaymentKeys: [...(this.state.refundedPaymentKeys || [])],
						restockItems: structuredClone(this.state.refundRestockItems || []),
					}}
					history={this.props.history}
					toggle={this.state.modalRefund}
					reportClose={this.closeRefundModal}
					afterSave={this.handleRefundModalAfterSave}
					size={'lg'}
					hideGoTo={true}
					project={'pos'}
				/>

			</div>
		)
	}
}

export default Framework.Components.withRootState(Layaway);
